import { CIcon } from '~/icons/types'

export const ciPartsAccessories: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M9.541 7.182a3.287 3.287 0 0 0-1.7-.4 3.425 3.425 0 0 0-1.8.4 2.616 2.616 0 0 0 1.8.9 2.227 2.227 0 0 0 1.7-.9Zm-3.4 7.602c.52.285 1.108.423 1.7.4a4.711 4.711 0 0 0 1.7-.4 2.206 2.206 0 0 0-3.4 0Z'
    },
    {
      d:
        'M11.041 8.284a2.65 2.65 0 0 1-.5-.6 3.143 3.143 0 0 1-2.6 1.4 3.366 3.366 0 0 1-2.7-1.3c-.28.18-.52.419-.7.7a3.174 3.174 0 0 1 1.3 2.6 3.553 3.553 0 0 1-1.2 2.6l.6.6a3.25 3.25 0 0 1 5.2 0c.224-.212.425-.447.6-.7a3.514 3.514 0 0 1-1.3-2.7 3.318 3.318 0 0 1 1.3-2.6Zm-3.2 4.51a1.685 1.685 0 0 1-1.7-1.7 1.628 1.628 0 0 1 1.7-1.7 1.7 1.7 0 0 1 0 3.4Z'
    },
    {
      d:
        'M7.841 3.785a7.2 7.2 0 1 0 7.2 7.2 7.168 7.168 0 0 0-7.2-7.2Zm0 12.4a5.2 5.2 0 1 1 5.2-5.2 5.162 5.162 0 0 1-5.2 5.2Z'
    },
    {
      d:
        'M11.641 9.184a2.25 2.25 0 0 0 0 3.6 5.264 5.264 0 0 0 .4-1.8 3.426 3.426 0 0 0-.4-1.8Zm-7.6.101a3.287 3.287 0 0 0-.4 1.7c-.012.623.126 1.24.4 1.8a2.29 2.29 0 0 0 .8-1.7 2.5 2.5 0 0 0-.8-1.8ZM23.14 5.886h-.3l-1.6.9a1.3 1.3 0 0 1-1.8-.4 1.282 1.282 0 0 1 .5-1.7l1.4-.8c.1-.1.2-.2.2-.3 0-.1-.1-.2-.2-.3a3.749 3.749 0 0 0-4.6 1.7 3.446 3.446 0 0 0 1.3 4.6l-2 7a2.445 2.445 0 0 0-1.9 2.1 2.07 2.07 0 0 0 1.6 2.2 2.227 2.227 0 0 0 2.6-1.2 2.135 2.135 0 0 0-.5-2.7l2-7a3.553 3.553 0 0 0 2.6-1.2 3.436 3.436 0 0 0 .9-2.7.215.215 0 0 0-.2-.2Zm-6.8 13.5a.8.8 0 1 1 0-1.6.8.8 0 0 1 0 1.6Zm-8.499-7.592a.7.7 0 1 0 0-1.4.7.7 0 0 0 0 1.4Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'parts-accessories',
  type: 'solid'
}
